/**
 * Checks if running in the context of the browser.
 * @returns {Boolean}
 */
export const isBrowser = () => typeof window !== 'undefined';

export default {};
